export default __webpack_public_path__ + "static/media/covid.9141d89a.mp4";